import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function ContactPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Contact - Equibre</title>
                <meta name="description" content="Connect us through any channel and we will respond as soon as possible." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Contact</h1>
                    <p>Connect us through any channel and we will respond as soon as possible.</p>
                </div>
            </section>
            <section className="work-section contact-list-section no-border">
                <div className="inner">
                    <div className="services-container" style={{ flexWrap: 'nowrap' }}>
                        <div className="service-card small -st">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" className="text-button">Live chat</a>
                                    <p>You can chat with us live on working hours.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        authCtx.toggleShowStartProjectDialog(true);
                                    }} className="text-button">Request a callback</a>
                                    <p>Write us in the contact form and we will be in touch with you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="mailto:contact@equibre.com" className="text-button">Send us email</a>
                                    <p>We always responds as fast as we can.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="https://blog.equibre.com" target="_blank" className="text-button">Visit our blogs</a>
                                    <p>Many peoples found our blogs helpful.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col ns-form">
                        <div>
                            <h1>Join our newsletter</h1>
                        </div>
                        <form className="newsletter-form">
                            <div>
                                <input required placeholder="Your email*" type="email" />
                            </div>
                            <div>
                                <button type="submit">Join</button>
                            </div>
                        </form>
                    </div>
                    <div className="col regr-off ns-form">
                        <div>
                            <h1>Registered office</h1>
                        </div>
                        <div><p>Unit 101 Oxford towers, 139 Hal Old Airport RD, Hulsur Bazaar, Bangalore- 560008, Karnataka, India</p></div>
                    </div>
                </div>
            </section>
            {/* <ContactListSection /> */}
        </>
    );
}